import React from "react";
import logo from "../assets/img/logoadutem.png";
import "../assets/css/styles.css";
import logoblanco from "../assets/img/logoADUTEMblanco.png";
import presidente from "../assets/img/presidente.png";
import primervicepresidente from "../assets/img/primervicepridente.jpeg";
import segundovicepresidente from "../assets/img/segundovicepresidente.jpeg";
import secretaria from "../assets/img/secretaria.jpeg";
import prosecretario from "../assets/img/prosecretario.jpeg";
import tesorera from "../assets/img/tesorera.jpeg";
import asesorajuridica from "../assets/img/asesorajuridica.jpeg";
import fotogrupal from "../assets/img/fotogrupal.jpeg";

const Nosotros = () => {
  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img
              src={logo}
              alt="Logo ADUTEM"
              height="90"
              className="logo-adutem"
            />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/">Inicio</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/nosotros">Nosotros</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/convenios">Convenios</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/eventos">Eventos</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/login">Login</a>
              </li>
              <li className="nav-item">
                <a className="btn btn-socio px-4 py-2 rounded-1" href="/sersocio">
                  Ser Socio
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ================= HERO NOSOTROS ================= */}
      <section
        className="py-5 text-white position-relative overflow-hidden d-flex align-items-center"
        style={{
          backgroundImage: "url(" + fotogrupal + ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh"
        }}
      >
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-black opacity-50"></div>

        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-2 fw-bold mb-4">¿Quiénes somos?</h1>
              <p className="lead fs-3 mb-5">
                ADUTEM es una asociación de docentes comprometida con el bienestar,
                la representación y el desarrollo profesional de sus socios.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MISIÓN, VISIÓN, DIRECTORIO ================= */}
      <section className="py-5 bg-light" id="mision">
        <div className="container">
          <div className="row g-5">
            {/* Misión */}
            <div className="col-lg-6">
              <h3 className="fw-bold text-verde-oscuro mb-4">Misión</h3>
              <p className="lead text-muted">
                Asociar, representar y defender los derechos, intereses y dignidad de los docentes
                de la Universidad Técnica de Manabí, promoviendo su desarrollo académico, científico,
                profesional y social. Busca fomentar la unidad, la solidaridad y la participación
                activa de sus miembros en la gestión universitaria, la investigación y la vinculación
                con la comunidad, garantizando condiciones dignas para el ejercicio de la docencia y
                contribuyendo al cumplimiento de los fines de la institución.
              </p>
            </div>

            {/* Visión */}
            <div className="col-lg-6">
              <h3 className="fw-bold text-verde-oscuro mb-4">Visión</h3>
              <p className="lead text-muted">
                Ser una organización gremial líder, sólida, transparente y representativa a nivel
                nacional, reconocida por su defensa firme de la estabilidad laboral y la excelencia
                académica de sus docentes. ADUTEM se proyecta como un actor clave en la construcción
                de una universidad pública de calidad, incluyente, científica y humanista, que
                promueva el bienestar integral de sus miembros y el desarrollo sostenible de la
                sociedad.
              </p>
            </div>
          </div>

          {/* Directorio */}
          <div className="mt-5">
            <h3 className="fw-bold text-center text-verde-oscuro mb-5">Directorio</h3>
            <div className="row g-4 justify-content-center">
              {[
                {
                  nombre: "ING. ALEX ALBERTO DUEÑAS RIVADENEIRA, PhD.",
                  cargo: "Presidente",
                  foto: presidente,
                  position: "center top"
                },
                {
                  nombre: "Ec. NILA MARISOL PLAZA MACÍAS, PhD.",
                  cargo: "Primer Vicepresidente",
                  foto: primervicepresidente,
                  position: "center top"
                },
                {
                  nombre: "LCDO. MIGUEL ANGEL ARTEAGA QUIROZ, PhD.",
                  cargo: "Segundo Vicepresidente",
                  foto: segundovicepresidente,
                  position: "center top"
                },
                {
                  nombre: "LCDA. GABRIELA ROSSANA GUERRERO ARAY, Mg.",
                  cargo: "Secretaria",
                  foto: secretaria,
                  position: "center top"
                },
                {
                  nombre: "ING. JIMMY JEFFREY GARCÍA VINCES, Mg.",
                  cargo: "Prosecretario",
                  foto: prosecretario,
                  position: "center 15%"   // ← aquí el fix para esta foto
                },
                {
                  nombre: "LCDA. ANGELICA BEATRIZ RUIZ CEDEÑO, PhD.",
                  cargo: "Tesorera",
                  foto: tesorera,
                  position: "center top"
                },
                {
                  nombre: "AB. MARÍA FERNANDA LINZÁN SALTOS, PhD.",
                  cargo: "Asesora Jurídica",
                  foto: asesorajuridica,
                  position: "center top"
                }
              ].map((miembro, index) => (
                <div className="col-md-6 col-lg-4" key={index}>
                  <div className="text-center">
                    <img
                      src={miembro.foto}
                      alt={miembro.nombre}
                      className="rounded-circle shadow mb-3"
                      width="180"
                      height="180"
                      style={{
                        objectFit: "cover",
                        objectPosition: miembro.position
                      }}
                      onError={(e) => {
                        e.target.style.background = "#e0e0e0";
                        e.target.src = "";
                      }}
                    />
                    <h5 className="fw-bold">{miembro.nombre}</h5>
                    <p className="text-muted">{miembro.cargo}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="bg-verde-oscuro text-white py-4">
        <div className="container">
          <div className="row align-items-center gy-4">

            {/* Logo y descripción */}
            <div className="col-lg-4 text-center text-lg-start">
              <img
                src={logoblanco}
                alt="Logo ADUTEM"
                height="60"
                className="me-3 mb-2"
              />
              <p className="mb-0 small opacity-80">
                Asociación de Docentes de la Universidad Técnica de Manabí
              </p>
            </div>

            {/* Dirección y Redes Sociales */}
            <div className="col-lg-4 text-center">
              <h6 className="fw-bold mb-2 small text-uppercase">Dirección</h6>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-geo-alt me-2"></i>
                Calle: Chile y Los Amigos
              </p>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-telephone me-2"></i>
                Teléfono: (05) 2632-200 / 0999162353
              </p>
              <p className="mb-3 small opacity-90">
                <i className="bi bi-envelope me-2"></i>
                adutem@utm.edu.ecs
              </p>

              <h6 className="fw-bold mb-3 small text-uppercase">Redes Sociales</h6>
              <div className="d-flex justify-content-center gap-4">
                <a href="https://www.instagram.com/adutem2025?igsh=MWU2aXJhZnh1Zjhtag==" className="text-white fs-4 opacity-80"><i className="bi bi-instagram"></i></a>
                <a href="https://www.facebook.com/share/1EQhuaFzqH/?mibextid=wwXIfr" className="text-white fs-4 opacity-80"><i className="bi bi-facebook"></i></a>
                <a href="https://youtube.com/@adutem?si=dluaO2vDTwiUwyfh" className="text-white fs-4 opacity-80"><i className="bi bi-youtube"></i></a>
              </div>
            </div>

            <div className="col-lg-4"></div>
          </div>

          <div className="text-center mt-3 pt-3 border-top border-secondary border-opacity-50">
            <small className="opacity-70">
              ADUTEM 2022 - 2025 © Todos los derechos reservados
            </small>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Nosotros;